/**
 * _calc_math.js — the rounding every trade calculator mirror shares.
 *
 * Mirrors application/utils/calculators/spec.py operation for operation: the
 * calculators answer instantly in the browser, and the server renders the same
 * answer for crawlers and for the no-JS form, so both must land on the same
 * digit. tests/fixtures/calculator_cases.json holds them equal
 * (tests/js/calculators.test.mjs and tests/unit/test_calculators.py).
 *
 * Not a *_controller.js file, so esm/index.js does not register it.
 */

/** Round to `places` decimals, halves up, in the same three float steps as Python. */
export function roundHalfUp(value, places) {
    const factor = 10 ** places;
    return Math.floor(value * factor + 0.5) / factor;
}

/** Round up to `places` decimals: an order quantity is never short. */
export function roundUp(value, places) {
    const factor = 10 ** places;
    return Math.ceil(roundHalfUp(value * factor, 6)) / factor;
}

/** Whole things to buy, without float noise turning 12.0000001 into 13. */
export function ceilWhole(value) {
    return Math.ceil(roundHalfUp(value, 6));
}

/** A rounded quantity as words print it: 2.5 not 2.50, 300 not 300.0. */
export function plainNumber(value) {
    return value.toFixed(2).replace(/0+$/, "").replace(/\.$/, "") || "0";
}

/**
 * A figure as the page prints it: grouped thousands, `places` decimals, ''
 * when there is no answer. Mirrors calculator_figure in
 * application/utils/calculators/display.py; values arrive already rounded.
 */
export function formatFigure(value, places) {
    if (value === null || value === undefined) return "";
    return value.toLocaleString("en-US", {
        minimumFractionDigits: places, maximumFractionDigits: places,
    });
}

/** Every output of a calculator set to null: the inputs give no answer. */
export function noAnswer(keys, warnings = []) {
    return { outputs: Object.fromEntries(keys.map((key) => [key, null])), items: [], warnings };
}
